import type { Event, EventHint } from "@sentry/types";

import { filters } from "@shared/utils/initSentry/filters";

export const beforeSend = (event: Event, hint: EventHint) => {
  for (const filter of filters) {
    const result = filter(event, hint);
    if (!result) return null;
  }

  return event;
};
